/**
 * Japanese copy for popup group “配信設定” fields. Must stay identical to site
 * `popupCsv` export column names for the same settings (import is positional).
 */
export const POPUP_GROUP_DISTRIBUTION_LABELS = {
  displayTargetContents: "要素を表示条件に追加する",
  disableTargetElements: "要素を非表示条件に追加する",
  deliverTargetUrls: "表示条件に該当ページを閲覧したユーザーを追加",
  deliverExcludeUrls: "非表示条件に該当ページを閲覧したユーザーを追加",
  targetCookies: "Cookieの条件を追加",
} as const;
